// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a98659da","239":"c37e4fb5","450":"97b9a6ae","455":"9991d86f","762":"33c41d33"}[chunkId] + ".chunk.js";
};